import type { ReactElement } from 'react';
import { Card, CardActions, Stack, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { PrimaryButton } from '@noah-labs/fe-shared-ui-components';
import type { MarkdownRemarkFrontmatterSolutionCards } from '../../../generated/types';
import { useBreakpoints } from '../../components/hooks/useBreakpoints';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.websiteBrand.greyscale.white, 0.8),
  border: `1px solid ${theme.palette.info.main}`,
  borderRadius: theme.borderRadius.sm,
  height: 'auto',
  padding: theme.spacing(3),
  width: '100%',
  [theme.breakpoints.down('md')]: {
    maxWidth: '300px',
  },
}));

export function HomepageSmallCard({
  button,
  link,
  subtitle,
  title,
}: MarkdownRemarkFrontmatterSolutionCards): ReactElement {
  const { isSmall } = useBreakpoints();
  return (
    <StyledCard elevation={0}>
      <Stack
        alignItems={isSmall ? 'center' : 'flex-start'}
        height="100%"
        justifyContent="space-between"
      >
        <Typography variant="paragraphBodyMBold">{title}</Typography>
        <Typography color="text.dark" marginTop={1} variant="paragraphBodyS">
          {subtitle}
        </Typography>
        {link && (
          <CardActions sx={{ mt: 2.5 }}>
            <PrimaryButton color="info" href={link} variant="outlined">
              {button}
            </PrimaryButton>
          </CardActions>
        )}
      </Stack>
    </StyledCard>
  );
}
